<script setup lang="ts" generic="T extends string">
import { computed } from 'vue'

import FooterListItem from './FooterListItem.vue'
import type { FooterListProps } from './types'
import { clsx } from 'clsx'

const props = withDefaults(defineProps<FooterListProps<T>>(), {
  direction: 'col',
})

const directions = {
  row: 'flex flex-col md:flex-row flex-wrap space-y-5 md:space-y-0 md:gap-x-5',
  col: 'flex flex-col space-y-3.75',
}

const computedColor = computed(() => {
  if (!props.colors || !props.color) {
    return undefined
  }
  return props.colors[props.color]
})
</script>

<template>
  <ul
    v-if="props.items?.length"
    :class="clsx(directions[direction], computedColor)"
  >
    <FooterListItem
      v-for="(item, index) in props.items"
      :key="index"
      :item="item"
      :color="computedColor"
      :data-cfid="item.sys.id"
    />
  </ul>
</template>
